import React from 'react';

import { Button, Group, Modal, Stack, Text, Title } from '@mantine/core';
import useDeleteAthleteClass from 'hooks/athleteClass/useDeleteAthleteClass';
import notificationHandler from 'utils/notifications';

interface IModalAthleteClassDelete {
  opened: boolean;
  handleClose: () => void;
  athleteKiloClassId?: string;
}

const ModalAthleteClassDelete = ({
  opened,
  athleteKiloClassId,
  handleClose,
}: IModalAthleteClassDelete): JSX.Element => {
  const deleteAthleteClass = useDeleteAthleteClass();

  const { successNotification, errorNotification } = notificationHandler();
  const handleDelete = (): void => {
    if (athleteKiloClassId) {
      deleteAthleteClass.mutate(athleteKiloClassId, {
        onSuccess: () => {
          successNotification('Athlete reservation delete success', `Reservation successfully deleted.`);
          handleClose();
        },
        onError: error => {
          errorNotification('Athlete reservation delete failed', error.response?.data.message);
        },
      });
    }
  };
  return (
    <Modal
      centered
      opened={opened}
      onClose={handleClose}
      title={<Title order={4}>Delete reservation</Title>}
      size='auto'
    >
      <Stack>
        <Text>{`Are you sure you want to delete this reservation?`}</Text>
        <Group position='right'>
          <Button onClick={handleDelete} color='red' loading={deleteAthleteClass.isLoading}>
            Delete
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default ModalAthleteClassDelete;
